import { initialiseDragAndDrop } from '../weeklyresources/manager.js';
import { toggleResourceVisibility } from '../home/index.js';

$(function () {
    // Function to highlight the anchor with the specified ID
    function highlightElement(anchorId) {
        let elementToHighlight;

        if (anchorId.startsWith('resource-') || anchorId.startsWith('new-resource-')) {
            // Extract resource and section numbers
            let prefixLength   = anchorId.startsWith('new-resource-') ? 13 : 9; // Length of 'new-resource-' or 'resource-'
            let idParts        = anchorId.slice(prefixLength).split('section-');
            let resourceNumber = idParts[0];
            let sectionNumber  = idParts[1];

            // Ensure the section/subsection is expanded fully
            let showMoreButton = $('#section' + sectionNumber + '-number-link');
            if (showMoreButton.length > 0) {
                let event = jQuery.Event('click');
                toggleResourceVisibility.call(showMoreButton, event);
            }

            elementToHighlight = $('#r-' + resourceNumber).parent();
        } else if (anchorId.startsWith('section-')) {
            let sectionNumber = anchorId.slice(8); // Length of 'section-'
            elementToHighlight = $('#s-' + sectionNumber);
        }

        const padding = 100;

        if (anchorId.startsWith('new-resource-')) {
            elementToHighlight.addClass('highlighted-new');
        } else {
            elementToHighlight.addClass('highlighted');
        }

        setTimeout(function () {
            $('html, body').animate({
                scrollTop: elementToHighlight.offset().top - padding,
            }, 'slow');
        }, 500);
    }

    // Check if there's a fragment in the URL
    if (window.location.hash) {
        var fragment = window.location.hash.substring(1);
        highlightElement(fragment);
    }

    $('#filter-container').removeClass('invisible');

    $('#filter-button').on('click', function () {
        const section    = $('select[name="section_name"]').val();
        const subsection = $('select[name="subsection_name"]').val();
        const type       = $('select[name="resource_type"]').val();
        const url        = $(this).data('url');
        const segments   = [type, section, subsection].filter(value => value !== '');

        window.location = url + segments.join('~') || url;
    });

    $('#reset-filter').on('click', function () {
        const url = $(this).data('url');
        window.location = url;
    });

    const selectedValues = [
        $('select[name="resource_type"]').find('option:selected').data('resource-type'),
        $('select[name="section_name"]').find('option:selected').data('resource-section'),
        $('select[name="subsection_name"]').find('option:selected').data('resource-subsection'),
    ];

    const alertText = selectedValues
        .filter(value => value) // Filter out empty values
        .map(value => `<strong>${value}</strong>`) // Wrap each value in <strong> tags
        .join(', '); // Join the values with commas

    $('.resource-alert').append('Page filtered by ' + alertText);

    if ($('#curriculum-resource-container').length > 0) {
        initialiseDragAndDrop();
    }

    // Get the initial selected section id
    var sectionIdValue = $('select[name="section_name"]').find(':selected').data('id');
    // Get the subsections for the selected section if it exists
    if (sectionIdValue !== undefined) {
        fetchSubsections(sectionIdValue);
    }

    // Open resource information modal
    $('.resource-info').on('click', function (e) {
        e.preventDefault();

        const resourceId   = $(this).data('id');
        const resourceName = $(this).data('name');

        $('.modal-title-text').text(resourceName);
        $('#resource-info-modal').modal('show');

        $.ajax({
            type: 'GET',
            url: base_url + 'pages/ajax_getResourceInfo',
            data: { resourceId: resourceId },
            dataType: 'json',
            beforeSend: function () {
                $('#resource-info-modal .modal-body').show().html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Loading Resource Information ...');
            },
            success: successResponse,
            error: function () {
                $('#resource-info-modal .modal-body').html('<p class="text-danger">Failed to load resource information.</p>');
            },
        });

        /**
         * On success, fetch resource information from AJAX request
         *
         * @param  object response
         * @return void
         */
        function successResponse(response) {
            if ($.isEmptyObject(response.resource)) {
                $('#resource-info-modal .modal-body').html('<p class="text-warning">No resource information available.</p>');
                return;
            }

            const academicYear       = response.academicYear;
            const resourcecontent    = response.resourcecontent;
            const sameDate           = response.sameDate;
            const restrictionsList   = response.restrictionsList;
            const yearSectionsList   = response.yearSectionsList;
            const weeklySectionsList = response.weeklySectionsList;

            const createdDateTime = resourcecontent.createddate;
            const createdByName   = resourcecontent.createdby_realname;
            const updatedDateTime = resourcecontent.lastmodifieddate;
            const updatedByName   = resourcecontent.lastmodifiedby_realname;

            const clicks         = response.clicks;
            const studentClicks  = Number(clicks?.student_clicks ?? 0);
            const totalClicks    = Number(clicks?.total_clicks ?? 0);
            const uniqueStudents = Number(clicks?.unique_student_users ?? 0);
            const hasValidClicks = clicks !== undefined && (studentClicks > 0 || studentClicks < totalClicks);

            let html = '<h4>Resource Timeline</h4>';
            html += '<p><strong>Created: </strong>' + createdDateTime + ' by ' + createdByName + '</p>';
            if (sameDate === true) {
                html += '<p><strong>Last Updated: </strong>' + updatedDateTime + ' by ' + updatedByName + '</p>';
            }

            html += '<h4>Years, Pages and Sections</h4>';
            html += yearSectionsList.length > 0
                ? '<ul>' + yearSectionsList.map(sec => '<li>' + (parseInt(sec.year) === 0 ? 'Years: All, ' : 'Year ' + sec.year + ', ') + 'Page: ' + sec.page_name + ', Section: ' + sec.section_name + (sec.subsection_name ? ', Subsection: ' + sec.subsection_name : '') + '</li>').join('') + '</ul>'
                : '<p><em>No Year/Sections.</em></p>';

            html += '<h4>Weekly Sections</h4>';
            html += weeklySectionsList.length > 0
                ? '<ul>' + weeklySectionsList.map(week => '<li>Year ' + week.programme_year + ', Week: ' + week.uoa_week + ', Section: ' + week.section_name + '</li>').join('') + '</ul>'
                : '<p><em>No weekly sections.</em></p>';

            html += '<h4>Restrictions</h4>';
            html += restrictionsList.length > 0
                ? restrictionsList.map(restriction => '<p><strong>Group:</strong> ' + restriction.groupname + ', <strong>Available From:</strong> ' + restriction.availablefrom + ' to ' + (restriction.availableto ?? '<em>No End Date</em>') + '</p>').join('')
                : '<p><em>No restrictions.</em></p>';

            html += '<h4>Resource Clicks for Academic Year: ' + academicYear + '</h4>';
            html += hasValidClicks
                ? '<p>' + studentClicks + ' ' + (studentClicks === 1 ? 'Click' : 'Clicks') + ' by ' + uniqueStudents + ' Students and ' + (totalClicks - studentClicks) + ' ' + (totalClicks - studentClicks === 1 ? 'Click' : 'Clicks') + ' by Staff</p>'
                : '<p><em>No clicks.</em></p>';

            $('#resource-info-modal .modal-body').html(html);
        }
    });
});

$('select[name="section_name"]').on('change', function () {
    var sectionId = $(this).find('option:selected').data('id');
    if (sectionId === undefined) {
        $('#subsections').empty().append($('<option>', {
            value: '',
            text: 'Select Subsection',
        }));
        $.each(subsectionNames, function (_, value) {
            const encodedValue = encodeURIComponent(value);
            $('#subsections').append($('<option>').prop('value', 'subsection:' + encodedValue).text(value));
        });
        $('#subsections').prop('disabled', false);
    } else {
        fetchSubsections(sectionId);
    }
});

/**
 * Fetches subsections based on the provided section ID
 * @param string sectionId - The ID of the selected section.
 */
function fetchSubsections(sectionId) {
    const data = {
        sectionId: sectionId,
    };

    const currentSelectedSubsection = $('select[name="subsection_name"]').find('option:selected').data('resource-subsection');

    $.ajax({
        type: 'GET',
        url: base_url + 'pages/ajax_getSubsections',
        data: data,
        dataType: 'json',
        success: function (data) {
            $('#subsections').empty().append($('<option>', {
                value: '',
                text: 'Select Subsection',
            }));

            if (data.length > 0) {
                $('#subsections').prop('disabled', false);
                $.each(data, function (_, section) {
                    let encodedName = encodeURIComponentIncludingBrackets(section.name);
                    let encodedValue = encodeURIComponent('subsection:' + encodedName);
                    // Decode HTML entities like &#40 and &#41 for proper display
                    let decodedName = $('<div/>').html(section.name).text();

                    $('#subsections').append($('<option>', {
                        value: encodedValue,
                        html: decodedName,
                    }));

                    if (section.name === currentSelectedSubsection) {
                        $('#subsections').val(encodedValue);
                    }
                });
            } else {
                $('#subsections').prop('disabled', true);
            }
        },
    });

    /**
     * Encodes a string with parentheses for use in a URL.
     *
     * @param  string stringToEncode
     * @return string
     */
    function encodeURIComponentIncludingBrackets(stringToEncode) {
        return encodeURIComponent(stringToEncode).replaceAll(
            /[()]/g,
            character => `%${character.codePointAt(0).toString(16)}`
        );
    }
}
